
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["stroke",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 926","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36.568 36.568"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 249","transform":"translate(1.698 1.643)","stroke":"#707070","stroke-width":"2"}},[_c('rect',{attrs:{"data-name":"Rectangle 146","width":"34.622","height":"10.784","rx":"3.49","transform":"rotate(-45 30.07 10.988)","fill":"#fff","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Path 531","d":"M9.506 31.054L.512 33.072a.365.365 0 01-.436-.436l2.018-8.994a.365.365 0 01.615-.178l6.975 6.976a.365.365 0 01-.178.614z","fill":"#fff","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Line 26","fill":"#fff","stroke-miterlimit":"10","d":"M21.438 4.153l7.51 7.51"}}),_c('path',{attrs:{"data-name":"Path 532","d":"M1.339 30.553L1 32.078l2.324-.438-1.792-1.791z","fill":"#707070"}}),_c('path',{attrs:{"data-name":"Line 27","fill":"#fff","stroke-linecap":"round","stroke-miterlimit":"10","d":"M8.918 24.228l13.519-13.519"}})])])
          )
        }
      }
    